import ApiBase from "./base";

export const _DASHBOARD_URL = "dashboard";

export async function getStatistics() {
    const response = await ApiBase.get(`${_DASHBOARD_URL}`);

    return response;
}

export async function getSalesStatistics(params = {}) {
    const response = await ApiBase.get(`${_DASHBOARD_URL}/sales`, { params });
    return response;
}

export async function getSSTStatistics(params = {}) {
    const response = await ApiBase.get(`${_DASHBOARD_URL}/sst`, { params });
    return response;
}

export async function getTopUpStatistics(params = {}) {
    const response = await ApiBase.get(`${_DASHBOARD_URL}/topup`, { params });
    return response;
}

export async function getProfitStatistics(params = {}) {
    const response = await ApiBase.get(`${_DASHBOARD_URL}/profit`, { params });
    return response;
}

export async function getUserStatistics(params = {}) {
    const response = await ApiBase.get(`${_DASHBOARD_URL}/user`, { params });
    return response;
}

export async function getDriverStatistics(params = {}) {
    const response = await ApiBase.get(`${_DASHBOARD_URL}/driver`, { params });
    return response;
}

export async function getManualTopUpStatistics(params = {}) {
    const response = await ApiBase.get(`${_DASHBOARD_URL}/manual-topup`, { params });
    return response;
}

